import styled, { css } from 'styled-components';

export const StyledSkeletonWrapper = styled.div(({ theme }) => {
  return css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    & .ant-skeleton-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 100% !important;

      & .anticon-dot-chart {
        display: none;
      }
    }
  `;
});
